/* Copyright (c) 2020-2024 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  FlexContainer,
  Heading,
  Spacer,
  Text,
  theme,
} from "@nordcloud/gnui";
import { BreadcrumbsBox } from "~/components";
import { isNil } from "~/tools";
import { lastChange, releaseNotes } from "./releaseNotes";

export function WhatsNew() {
  localStorage.setItem("releaseNotes", String(Date.now()));

  return (
    <>
      <BreadcrumbsBox title="Release notes" />
      {releaseNotes.map(
        (
          ReleaseNote // eslint-disable-line @typescript-eslint/naming-convention
        ) => (
          <>
            <Box>
              <ReleaseNote />
            </Box>
            <Spacer height={theme.spacing.spacing04} />
          </>
        )
      )}
    </>
  );
}

export function WhatsNewPopup() {
  const [show, setShow] = React.useState(false);
  const navigate = useNavigate();

  React.useEffect(() => {
    const lastRelease = localStorage.getItem("release");

    // Don't show this window for new users.
    if (isNil(lastRelease)) {
      localStorage.setItem("release", lastChange);
    }

    if (localStorage.getItem("release") !== lastChange) {
      setShow(true);
    }
  }, []);

  const dismiss = () => {
    localStorage.setItem("release", lastChange);
    setShow(false);
  };

  if (!show) {
    return null;
  }

  return (
    <Box>
      <FlexContainer justifyContent="space-between">
        <Heading level={4} mb={theme.spacing.spacing04}>
          <span role="img" aria-label="announcement">
            🎉🎉🎉
          </span>{" "}
          We&apos;ve just released a new version{" "}
          <span role="img" aria-label="announcement">
            🎉🎉🎉
          </span>
        </Heading>
        <Button
          icon="close"
          size="sm"
          severity="low"
          mt={`-${theme.spacing.spacing04}`}
          onClick={dismiss}
        />
      </FlexContainer>
      <Text mb={theme.spacing.spacing05}>
        In our latest December release, we&apos;ve{" "}
        <strong>enhanced Estate Records page</strong> for a detailed breakdown
        of your cloud cost.
      </Text>
      <Button
        size="md"
        onClick={() => {
          dismiss();
          navigate("/release");
        }}
      >
        Read more
      </Button>
    </Box>
  );
}
